import React from 'react';
import './Footer.scss';

const Footer = (props) => {
    return (
        <div className="footer">
            <div>
                <span>
                East Front Series, EFS, Typhoon! The Drive on Moscow 1941, Barbarossa Army Group North, Barbarossa Army Group Center,
                </span>
            </div>
            <div>
            <span>
                Barbarossa Army Group South, Barbarossa Kiev to Rostov 1941, Barbarossa Crimea 1941-42 are Trademarks of GMT Games, Hanford, CA.
                </span>
             </div>
        </div>
    );
}

export default Footer;